const LIKE_ICON = [
  {
    src: new URL('~/public/assets/images/icons/likeIcon.png', import.meta.url)
      .href,
    alt: 'Like',
    as: 'image/png'
  }
]

export default LIKE_ICON
